<template>
	<div>
		<div class="table-cont" v-if="portfolioSetUp">
			<table class='table table-bordered table-stripped table-hover'>
				<tr>
					<td>TWR</td>
					<td>{{portfolio.twr.toFixed(3)}} %</td>
				</tr>
				<tr>
					<td>Drawdown</td>
					<td>{{portfolio.drawdown.toFixed(3)}}</td>
				</tr>
				<tr>
					<td>Rating</td>
					<td>{{portfolio.rating.toFixed(2)}}</td>
				</tr>
				<tr>
					<td>Term</td>
					<td>{{portfolio.term}}</td>
				</tr>
			</table>
		</div>

		<div class="table-cont" v-if="portfolioSetUp">
			<table class='table table-bordered table-stripped table-hover'>
				<tr>
					<td>Profit</td>
					<td>{{portfolio.profit.toFixed(2)}} {{portfolio.currency}}</td>
				</tr>
				<tr>
					<td>Sharp</td>
					<td>{{portfolio.sharp.toFixed(3)}}</td>
				</tr>
				<tr>
					<td>Sortino</td>
					<td>{{portfolio.sortino.toFixed(3)}}</td>
				</tr>
				<tr>
					<td>Orders total</td>
					<td>108</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['portfolio'],
		data() {
			return { 
				
			};
		},
		computed: {
			portfolioSetUp() {
				return (typeof this.portfolio.id !== 'undefined');
			}
		},
		methods: {
		}
	};
</script>

<style scoped>
	.table-cont {
		display: inline-block;
		margin-right: 8px;
	}
</style>